import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gr_admin_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const submitContact = (data) => api.post("/contact", data).then((r) => r.data);
export const sendChat = (session_id, message) =>
  api.post("/chat", { session_id, message }).then((r) => r.data);
export const submitChatQuote = (data) =>
  api.post("/chat/submit-quote", data).then((r) => r.data);
export const adminLogin = (email, password) =>
  api.post("/admin/login", { email, password }).then((r) => r.data);
export const fetchContacts = () => api.get("/contact").then((r) => r.data);
export const updateContactStatus = (id, status) =>
  api.patch(`/contact/${id}?status=${status}`).then((r) => r.data);
export const deleteContact = (id) => api.delete(`/contact/${id}`).then((r) => r.data);
export const fetchStats = () => api.get("/admin/stats").then((r) => r.data);
export const fetchChatAnalytics = (window = "all") =>
  api.get(`/admin/chat-analytics?window=${window}`).then((r) => r.data);

export const exportContactsCsvUrl = (source) => {
  const token = localStorage.getItem("gr_admin_token");
  const q = source ? `?source=${source}` : "";
  // Note: token must be on Authorization header — we'll fetch as blob below.
  return { url: `${API}/admin/contacts/export.csv${q}`, token };
};

export const fetchContactNotes = (contactId) =>
  api.get(`/contact/${contactId}/notes`).then((r) => r.data);
export const addContactNote = (contactId, body) =>
  api.post(`/contact/${contactId}/notes`, { body }).then((r) => r.data);
export const deleteContactNote = (contactId, noteId) =>
  api.delete(`/contact/${contactId}/notes/${noteId}`).then((r) => r.data);

export const fetchPublicPosts = () => api.get("/posts").then((r) => r.data);
export const fetchPublicPost = (slug) => api.get(`/posts/${slug}`).then((r) => r.data);
export const fetchAdminPosts = () => api.get("/admin/posts").then((r) => r.data);
export const fetchAdminPost = (id) => api.get(`/admin/posts/${id}`).then((r) => r.data);
export const createPost = (data) => api.post("/admin/posts", data).then((r) => r.data);
export const updatePost = (id, data) => api.patch(`/admin/posts/${id}`, data).then((r) => r.data);
export const deletePost = (id) => api.delete(`/admin/posts/${id}`).then((r) => r.data);
